import { render } from "./ModalBase.vue?vue&type=template&id=642d93e0&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=642d93e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642d93e0"]])

export default __exports__